<template>
  <ol class="pp" aria-label="Путь">
    <li v-for="s in steps" :key="s.key" :class="['pp-step', `is-${s.state}`]" :title="s.hint">
      <span class="pp-mark" aria-hidden="true">{{ s.state === 'done' ? '✓' : s.state === 'current' ? '●' : '' }}</span>
      <span class="pp-t">{{ s.title }}</span>
    </li>
  </ol>
</template>

<script setup>
// Путь одного объекта по этапам: пройдено, сейчас, впереди. Общий компонент. [Claude, 03.11.2026]
defineProps({ steps: { type: Array, default: () => [] } })
</script>

<style scoped>
.pp { list-style: none; margin: 0; padding: 0; display: flex; flex-wrap: wrap; gap: 4px 0; }
.pp-step { display: flex; align-items: center; gap: 6px; font-size: 12.5px; color: #9ca3af; }
.pp-step:not(:last-child)::after { content: ''; width: 18px; height: 2px; margin: 0 6px; background: #e7e5df; border-radius: 2px; }
.pp-mark { width: 18px; height: 18px; border-radius: 50%; display: inline-grid; place-items: center; font-size: 10px; border: 2px solid #e7e5df; background: #fff; }
.pp-step.is-done { color: #374151; } .pp-step.is-done .pp-mark { background: #16a34a; border-color: #16a34a; color: #fff; }
.pp-step.is-done:not(:last-child)::after { background: #16a34a; }
.pp-step.is-current { color: #1f2430; font-weight: 700; } .pp-step.is-current .pp-mark { border-color: #f2b705; color: #b98900; box-shadow: 0 0 0 4px rgba(242, 183, 5, .18); }
</style>
